module.exports = {"term_agreement_by_ll_owner":"Términos del acuerdo por parte del propietario / propietario"};